import { Component, OnInit } from '@angular/core';
import { NgbDropdownConfig } from '@ng-bootstrap/ng-bootstrap';
import { Router } from '@angular/router';
import { WebapiService } from 'src/app/webapi.service';
import { AuthService } from 'src/app/auth/auth.service';
@Component({
  selector: 'app-navbar',
  templateUrl: './navbar.component.html',
  styleUrls: ['./navbar.component.scss'],
  providers: [NgbDropdownConfig]
})
export class NavbarComponent implements OnInit {
  public iconOnlyToggled = false;
  public sidebarToggled = false;
  userName:any

  constructor(
    config: NgbDropdownConfig,
    private router:Router,
    private webapiservice:WebapiService,
    private authService: AuthService
  ) {
    config.placement = 'bottom-right';
  }

  ngOnInit() {
    this.userName = sessionStorage.getItem('name')
  }

  // toggle sidebar in small devices
  toggleOffcanvas() {
    document.querySelector('.sidebar-offcanvas').classList.toggle('active');
  }

  trackUser(empId:any,event:any){
    let val = {
      employeeId:empId,
      eventType:event,
      eventDescription:'Log out from Panel'
    }
    this.webapiservice.trackUser(val).subscribe((res:any)=>{
       console.log(res);
       
    });
  }
  logOut(){
    let id = sessionStorage.getItem('loginId');
    let added = sessionStorage.getItem('addedId');
    if(id == '670654c31539eee3796d1872' || added == '670654c31539eee3796d1872'){
      this.trackUser(id,"logout");
    }
    
    // Use AuthService to handle logout
    this.authService.logout();
    // No need to navigate as AuthService.logout() already handles redirection
  }

  // toggle sidebar
  toggleSidebar() {
    let body = document.querySelector('body');
    if((!body.classList.contains('sidebar-toggle-display')) && (!body.classList.contains('sidebar-absolute'))) {
      this.iconOnlyToggled = !this.iconOnlyToggled;
      if(this.iconOnlyToggled) {
        body.classList.add('sidebar-icon-only');
      } else {
        body.classList.remove('sidebar-icon-only');
      }
    } else {
      this.sidebarToggled = !this.sidebarToggled;
      if(this.sidebarToggled) {
        body.classList.add('sidebar-hidden');
      } else {
        body.classList.remove('sidebar-hidden');
      }
    }
  }

  // toggle right sidebar
  // toggleRightSidebar() {
  //   document.querySelector('#right-sidebar').classList.toggle('open');
  // }

}
